// extracted by mini-css-extract-plugin
export default {"tableWrapper":"_201jQ","table":"_1MVR8","sortIcon":"_3YgUS","paymentMode":"sfwU0","download":"CeMPj"};